import FashionPortfolio1 from './../images/works/Fashion Portfolio/Page_30_Fashion-Portfolio.jpg'
import FashionPortfolio2 from './../images/works/Fashion Portfolio/Page_42_Fashion-Portfolio.jpg'
import FashionPortfolio3 from './../images/works/Fashion Portfolio/Page_51.jpg'

const FashionPortfolio = [FashionPortfolio1, FashionPortfolio2, FashionPortfolio3]

export default FashionPortfolio